import { handlers } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;

async function getAll() {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: '/global?type=KPIs'
      }))
  );
}

const kpiSetService = {
  getAll,
};

export default kpiSetService;
